import { getClient } from './axios';

const fetchCampaignTime = (params) => getClient()?.get(`/campaigntime`, { params });
const updateCampaignTime = (body) => getClient()?.put(`/campaigntime`, body);

export const campaignTimeService = {
  fetchCampaignTime,
  updateCampaignTime,
};
